import { CompassIcon, SplitIcon, TrendingUpIcon, ZapIcon, FlagIcon } from 'lucide-react';

export const infoSources = [
  'Entrenamientos de natación',
  'Sesiones de ciclismo',
  'Planes de carrera',
  'Consejos de nutrición',
  'Recomendaciones de recuperación',
  'Listas de preparación para competir',
];

export const selfQuestions = [
  '¿Estoy entrenando lo suficiente?',
  '¿Estoy entrenando demasiado?',
  '¿Qué debería hacer esta semana?',
  '¿Cómo puedo equilibrar natación, ciclismo y carrera?',
  '¿Cuándo debería aumentar el esfuerzo?',
  '¿Cuándo debería priorizar la recuperación?',
  '¿Cómo organizo la alimentación para las sesiones largas?',
  '¿Cómo puedo evaluar si estoy progresando?',
  '¿Qué debería preparar cuando se acerque la competición?',
];

export const painPoints: {
  icon: typeof CompassIcon;
  title: string;
  body: string[];
  list?: string[];
  resolve?: string;
}[] = [
  {
    icon: CompassIcon,
    title: 'No sabes por dónde empezar',
    body: [
      'Preparar un triatlón requiere organizar distintas disciplinas y prestar atención a diferentes aspectos del entrenamiento.',
      'Sin una estructura clara, es fácil saltar de un entrenamiento a otro sin comprender cómo encajan las distintas partes de la preparación.',
    ],
    resolve: 'SISTEMA TRIATLÓN COMPLETO™ organiza los fundamentos de tu preparación en seis volúmenes temáticos.',
  },
  {
    icon: SplitIcon,
    title: 'Tus tres disciplinas parecen desconectadas',
    body: [
      'Natación. Ciclismo. Running. Tres disciplinas. Un mismo desafío.',
      'Tu preparación necesita contemplar las tres disciplinas dentro de una visión global, en lugar de tratarlas como actividades completamente independientes.',
    ],
  },
  {
    icon: TrendingUpIcon,
    title: 'No sabes si realmente estás progresando',
    body: [
      'Entrenar más no significa necesariamente entrenar mejor.',
      'Sin una forma organizada de registrar tus sesiones y observar tu evolución, puede resultar difícil comprender cómo estás distribuyendo tu esfuerzo y qué aspectos de tu rutina necesitan atención.',
    ],
  },
  {
    icon: ZapIcon,
    title: 'No tienes clara la parte de la nutrición',
    body: [
      'Las pruebas de resistencia requieren prestar atención a la alimentación, la hidratación y la gestión de la energía.',
      'El entrenamiento es solo una parte de la preparación. Comprender cómo organizar estos aspectos también puede ayudarte a llegar mejor preparado a tus sesiones y a la competición.',
    ],
  },
  {
    icon: FlagIcon,
    title: 'Te preocupa el día de la carrera',
    body: ['Puedes dedicar mucho tiempo a entrenar y, aun así, llegar a la semana de competición preguntándote:'],
    list: [
      '¿Qué necesito llevar?',
      '¿Qué debo preparar la noche anterior?',
      '¿Cómo organizo la mañana de la prueba?',
      '¿Qué debo tener en cuenta durante las transiciones?',
      '¿Cómo puedo organizar mi estrategia para las distintas etapas?',
    ],
    resolve: 'Una competición bien preparada no empieza en la línea de salida. Empieza mucho antes.',
  },
];
